import React from 'react'
import dynamic from 'next/dynamic'
import PropTypes from 'prop-types'
import Layout from '@shared/components/layout'
const PopularPlayers = dynamic(() => import('@shared/components/player/popularPlayers'))
const PlayersList = dynamic(() => import('@shared/components/player/playersList'))
const ATSAds = dynamic(() => import('@shared/components/atsAds'), { ssr: false })

function Players({ seoData, popularPlayers, allPlayers, filteredPlayers, isFiltered, totalCount }) {
  return (
    <Layout data={{ oSeo: seoData }} customAmpEnable>
      <ATSAds />
      <PopularPlayers popularTeams={popularPlayers} />
      <PlayersList allTeams={allPlayers} filteredTeams={filteredPlayers} totalCount={totalCount} />
    </Layout>
  )
}
Players.propTypes = {
  seoData: PropTypes.object,
  popularPlayers: PropTypes.array,
  allPlayers: PropTypes.array,
  filteredPlayers: PropTypes.array,
  isFiltered: PropTypes.bool,
  totalCount: PropTypes.number
}

export async function getServerSideProps({ req, res, params, query, resolvedUrl }) {
  try {
    const queryGraphql = (await import('@shared/components/queryGraphql')).default
    const { checkRedirectionStatus } = (await import('@shared-submodule/utils'))
    const GET_SEO_DATA = (await import('@graphql/article/article.query')).GET_SEO_DATA
    const { data: seo } = await queryGraphql(GET_SEO_DATA, { input: { sSlug: 'cricket/players' } })
    const { redirectStatus, eCode, returnObj, props } = checkRedirectionStatus(seo?.getSeoData)
    if (redirectStatus && props) {
      res.statusCode = eCode
      return { props }
    } else if (redirectStatus) return returnObj
    const GET_TRENDING_PLAYERS = (await import('@shared-submodule/sm-graphql/players/players.query')).GET_TRENDING_PLAYERS
    const { data: popularPlayers } = await queryGraphql(GET_TRENDING_PLAYERS)
    if (query?.gender || query?.nationality || query?.sSearch || query?.international === 'true' || query?.activePlayers === 'true' || query?.role || query?.startsWith) {
      const filterInput = {
        nSkip: 1,
        nLimit: 18
      }
      if (query?.sSearch) {
        filterInput.sSearch = query?.sSearch
      } else if (query?.startsWith) {
        filterInput.startsWith = query?.startsWith
      } else {
        filterInput.startsWith = 'A'
      }
      if (query?.international === 'true') {
        filterInput.international = true
      }
      if (query?.activePlayers === 'true') {
        filterInput.activePlayers = true
      }
      if (query?.role) {
        filterInput.role = query?.role
      }
      if (query?.nationality) {
        filterInput.nationality = query?.nationality
      }
      if (query?.gender) {
        filterInput.gender = query?.gender
      }
      const PLAYERS_LIST_WITH_FILTERS = (await import('@shared-submodule/sm-graphql/players/players.query')).PLAYER_SEARCH
      const { data: filteredPlayers } = await queryGraphql(PLAYERS_LIST_WITH_FILTERS, {
        input: { ...filterInput }
      })
      return {
        props: {
          seoData: seo?.getSeoData,
          popularPlayers: popularPlayers?.getTrendingPlayers || [],
          filteredPlayers: filteredPlayers?.filterPlayerDetails?.aPlayerDetails || [],
          totalCount: filteredPlayers?.filterPlayerDetails?.nTotalCount || 0,
          isFiltered: true
        }
      }
    } else {
      const GET_PLAYERS_LIST_WITH_SERIES = (await import('@shared-submodule/sm-graphql/players/players.query')).PLAYER_SEARCH
      const { data: allPlayers } = await queryGraphql(GET_PLAYERS_LIST_WITH_SERIES, {
        input: {
          startsWith: 'A',
          nSkip: 1,
          nLimit: 18
        }
      })
      return {
        props: {
          seoData: seo?.getSeoData,
          popularPlayers: popularPlayers?.getTrendingPlayers || [],
          allPlayers: allPlayers?.filterPlayerDetails?.aPlayerDetails || [],
          totalCount: allPlayers?.filterPlayerDetails?.nTotalCount || 0
        }
      }
    }
  } catch (e) {
    console.log({ e })
    res.setHeader('Cache-Control', 'no-cache')
    const handleApiError = (await import('@shared-submodule/utils')).handleApiError
    const status = handleApiError(e, resolvedUrl)
    return status
  }
}

export default Players
